export const PAGE_PATH = '/cookie-use-policy';
